import React from "react";
import { ReactComponent as ModeratorVerifiedIcon } from "../../Resources/image/verified-check.svg";
import { t } from "../../utils/i18n";
import styles from "./ModeratorVerifiedBadge.module.css";

/**
 * 话题认证版主标识（与 TopicDetail 侧栏图标一致）
 */
const ModeratorVerifiedBadge = ({ className = "" }) => (
  <span
    className={[styles.wrap, className].filter(Boolean).join(" ")}
    role="img"
    aria-label={t("topic.aria.verifiedModerator", "Verified moderator")}
  >
    <ModeratorVerifiedIcon className={styles.icon} aria-hidden />
  </span>
);

export default ModeratorVerifiedBadge;
